export default function () {
  return window.sessionStorage && window.sessionStorage.getItem && window.sessionStorage.removeItem ? true : false;
}
